<form *ngIf="editorForm" [formGroup]="editorForm" class="welcome-page-form__container">
  <mat-card class="welcome-page-form__card">
    <mat-card-title>
      <div class="title">
        <div class="eiq-id-badge">
          <fa-icon [icon]="faHandWave"></fa-icon>
        </div>
        <span class="fs__sm fw__500">Welcome screen</span>
      </div>

      <div class="actions">
        <button mat-icon-button title="Add Stimulus" class="settings-btn" (click)="onAddStimulus()">
          <fa-icon [icon]="faPhotoFilm"></fa-icon>
        </button>
      </div>
    </mat-card-title>
    <mat-card-content>
      <div class="welcome-page-form__content">
        @if ((editorForm.get('welcomeStimulus') | toFormArray).controls.length > 0) {
          <empathy-shared-stimulus
            [stimulus]="editorForm.get('welcomeStimulus').value"
            [height]="130"
            [width]="130"
            (delete)="onDeleteMedia($event)"
          ></empathy-shared-stimulus>
        }

        <div class="editor-question-form__input">
          <span class="label fs__sm">Title</span>
          <empathy-text-editor id="welcome_title" [settings]="inputSettings" [control]="editorForm.get('title')"></empathy-text-editor>
        </div>

        <mat-divider></mat-divider>

        <div class="editor-question-form__input">
          <span class="label fs__sm">Message</span>
          <empathy-text-editor
            id="welcome"
            [settings]="textareaSettings"
            [control]="editorForm.get('welcomeHtml')"
            [allowLineBreaks]="true"
          ></empathy-text-editor>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
